import { RefreshCw } from 'lucide-react';
import { applyUpdate } from '../app/serviceWorker';
import { useEditorStore } from '../state/editorStore';

/**
 * Offers to reload when a new version has been deployed.
 *
 * Deliberately a user action: reloading silently would discard whatever the
 * person is mid-way through drawing. Nothing is lost by waiting either — the
 * current version keeps working until they choose.
 */
export function UpdateBanner() {
  const available = useEditorStore((s) => s.updateAvailable);
  if (!available) return null;
  return (
    <div
      className="pointer-events-auto fixed bottom-10 left-3 z-40 flex items-center gap-2 rounded-lg border border-line bg-surface px-3 py-2 shadow-xl"
      data-testid="update-banner"
      role="status"
    >
      <RefreshCw size={14} className="text-accent" aria-hidden="true" />
      <span className="text-[12px] text-ink">A new version is ready</span>
      <button
        type="button"
        onClick={applyUpdate}
        data-testid="update-reload"
        className="rounded-md bg-accent-strong px-2 py-1 text-[12px] font-medium text-accent-ink hover:brightness-110"
      >
        Reload
      </button>
    </div>
  );
}
